import type { WalkthroughGroup } from '@mesa/core/pull';
import { queryOptions, useMutation } from '@tanstack/react-query';

import { api, queryClient } from '@/lib/clients';

export const walkThroughQuery = (owner: string, repo: string, pull_number: number) =>
  queryOptions({
    queryKey: [owner, repo, 'pull', pull_number, 'walkthrough'],
    queryFn: async () => {
      // if (repo === 'cal.com' && pull_number === 20315) {
      //   return demoWalkthrough;
      // }
      // if (repo === 'cal.com' && pull_number === 20302) {
      //   return demoWalkthrough2;
      // }
      const res = await api.github[':owner'][':repo']['pulls'][':pull_number']['walkthrough'].$get({
        param: {
          owner,
          repo,
          pull_number: pull_number.toString(),
        },
      });
      const data = await res.json();
      return data;
    },
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });

export const useWalkthroughMutations = (owner: string, repo: string, pull_number: number) => {
  const { mutate: generateWalkthrough } = useMutation({
    mutationFn: async () => {
      const res = await api.github[':owner'][':repo']['pulls'][':pull_number']['walkthrough'].$get({
        param: {
          owner,
          repo,
          pull_number: pull_number.toString(),
        },
      });
      const data = await res.json();
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: walkThroughQuery(owner, repo, pull_number).queryKey,
      });
    },
  });

  return { generateWalkthrough };
};
